import { Component, inject, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-card-widget',
    standalone: false,
    templateUrl: './card-widget.component.html',
    styleUrl: './card-widget.component.scss'
})
export class CardWidgetComponent {
    private readonly router = inject(Router);
    private readonly route = inject(ActivatedRoute);
    irARuta() {
        if (this.ruta && this.ruta.length > 0) {
            this.router.navigate(this.ruta, { relativeTo: this.route });
        }
    }

    @Input() titulo: string = '';
    @Input() subtitulo: string = '';
    @Input() icon: string = '';
    @Input() iconBg: string = '';
    @Input() iconColor: string = '';
    @Input() ruta: string[] = [];
    @Input() actionText: string = '';
    @Input() lastActionDate: string = '';
}
